import { render, staticRenderFns } from "./jointOrderAList.vue?vue&type=template&id=585f3e41&scoped=true&"
import script from "./jointOrderAList.vue?vue&type=script&lang=js&"
export * from "./jointOrderAList.vue?vue&type=script&lang=js&"
import style0 from "./jointOrderAList.vue?vue&type=style&index=0&id=585f3e41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f3e41",
  null
  
)

export default component.exports